import { useState, MouseEvent } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import SuccessDialog from './FormComponents/SuccessDialog';
import { StyledLoadingButton } from '../../../../components/forms/LoadingButton';
import ApiKeysContainer from '../../ApiKeysContainer';

const StyledRegenDiv = styled.div`
    margin-top: 24px;
    margin-bottom: 12px;
    background: #ff98001a;
    display: flex;
    align-items: center;
    padding: 15px 10px;
`;

const StyledRegenButton = styled(Button)`
    margin-right: 10px;
    border-color: #eb1414;
    color: #eb1414;
`;

const StyledWarnSpan = styled.span`
    font-weight: bold;
`;

const RegenerateKey: React.FC = () => {
    const { t } = useTranslation('admin_settings');
    const [openRegenerateDialog, setOpenRegenerateDialog] = useState<boolean>(false);
    const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
    const { isRegenerating, regenerateApiKey, selectedKey, keyValue } = useContainer(ApiKeysContainer);
    const { path } = useRouteMatch();
    const history = useHistory();

    const handleRegenerate = async (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        await regenerateApiKey(selectedKey);
        setOpenRegenerateDialog(false);
        setOpenSuccessDialog(true);
    };

    const handleSuccessClose = () => {
        setOpenSuccessDialog(false);
        history.push(path.replace('/edit', ''));
    };

    const renderRegenerateDialog = () => (
        <Dialog open={openRegenerateDialog} onClose={() => setOpenRegenerateDialog(false)}>
            <DialogTitle>{t('api-keys.regenerate-key-title')}</DialogTitle>
            <DialogContent>{t('api-keys.regenerate-key-warning')}</DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenRegenerateDialog(false)} variant="outlined">
                    {t('cancel')}
                </Button>
                <StyledLoadingButton
                    sx={{ marginLeft: '10px' }}
                    onClick={handleRegenerate}
                    loading={isRegenerating}
                    variant="contained"
                    color="error"
                >
                    {t('api-keys.regenerate-key')}
                </StyledLoadingButton>
            </DialogActions>
        </Dialog>
    );
    return (
        <>
            <StyledRegenDiv>
                <StyledRegenButton onClick={() => setOpenRegenerateDialog(true)} variant="outlined">
                    {t('api-keys.buttons.regen-key')}
                </StyledRegenButton>
                <Typography>
                    <StyledWarnSpan>{t('api-keys.buttons.regen-warning')}</StyledWarnSpan>{' '}
                    {t('api-keys.buttons.regen-description')}
                </Typography>
            </StyledRegenDiv>
            {renderRegenerateDialog()}
            <SuccessDialog
                open={openSuccessDialog}
                handleClose={handleSuccessClose}
                createdKey={selectedKey}
                secret={keyValue}
            />
        </>
    );
};

export default RegenerateKey;
